import { type BlankProductData, BlankSingleSideEnum, type PrintArea } from "../../../interfaces/blank";
import { getPreviewImageToUpload } from "./getPreviewImageToUpload";

export const uploadPreviewImage = async ({
  blankImages,
  customizationSettings,
  color,
  uploadFile,
}: {
  blankImages: BlankProductData["images"];
  customizationSettings: {
    [k in BlankSingleSideEnum]?: {
      area: PrintArea;
      imageSrc: string;
      printArea: PrintArea;
    };
  };
  color: string;
  uploadFile: (payload: FormData) => Promise<{
    fileName?: string;
    message?: string;
    status?: number;
  }>;
}) => {
  const previewImages = await getPreviewImageToUpload({
    blankImages,
    customizationSettings,
    color,
  });

  if (previewImages.length > 0) {
    const { blob } = previewImages[0];

    const formData = new FormData();
    formData.append("file", blob);

    const res = await uploadFile(formData);

    return {
      ...res,
      type: "preview",
    };
  }

  return {
    type: "preview",
  };
};
